import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';

export const AuthRegisterRequest = object('AuthRegisterRequest', {
  tenant: string(),
  realm: string(),
  provider: string(),
  username: string(),
  password: string(),
});
